import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Tabs from "./Tabs";

function AddUser() {
  const navigate = useNavigate();
  //Tambah Akun/Register
  const [dataRegister, setDataRegister] = useState({
    name: "",
    username: "",
    email: "",
    password: "",
    phone: "",
    profile_pict: "",
    role: "",
  });
  const [selectedFile, setSelectedFile] = useState(null);

  const handleCancel = () => {
    navigate("/admin/user");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDataRegister((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleFileUpload = async () => {
    if (!selectedFile) return;

    const data = new FormData();
    data.append("file", selectedFile);

    try {
      const response = await axios.post("/api_w/upload/single", data, {
        headers: {
          "Content-Type": "multipart/form-data",
          db_name: process.env.REACT_APP_DB_NAME,
        },
      });
      return response.data.data.Location;
    } catch (error) {
      toast.error(
        "Error Upload Gambar: " +
          (error.response?.data?.message || error.message)
      );
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      const imageURL = await handleFileUpload();
      const postData = {
        ...dataRegister,
        profile_pict: imageURL,
      };
      const config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "/api_w/users/register",
        headers: {
          Authorization: `${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
          db_name: process.env.REACT_APP_DB_NAME,
        },
        data: JSON.stringify(postData),
      };
      const response = await axios.request(config);
      console.log(JSON.stringify(response.data));
      toast.success("Berhasil Tambah Akun");
      navigate("/admin/user");
    } catch (error) {
      toast.error(
        "Error Tambah Akun: " + (error.response?.data?.message || error.message)
      );
    }
  };

  //Change Password
  const [dataChangePassword, setDataChangePassword] = useState({
    oldPassword: "",
    newPassword: "",
    newPasswordValidate: "",
  });

  const handleChangeUbahPassword = (e) => {
    const { name, value } = e.target;
    setDataChangePassword((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (
      dataChangePassword.newPassword !== dataChangePassword.newPasswordValidate
    ) {
      toast.error("Password baru & konfirmasi password tidak cocok.");
      return;
    }
    try {
      const postDataChangePass = {
        ...dataChangePassword,
      };
      const config = {
        method: "put",
        maxBodyLength: Infinity,
        url: "/api_w/users/changepassword",
        headers: {
          Authorization: `${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
          db_name: process.env.REACT_APP_DB_NAME,
        },
        data: JSON.stringify(postDataChangePass),
      };
      const response = await axios.request(config);
      console.log(JSON.stringify(response.data));
      toast.success("Berhasil Ubah Password");
      navigate("/admin/user");
    } catch (error) {
      toast.error(
        "Error Ubah Password: " +
          (error.response?.data?.message || error.message)
      );
    }
  };

  //Reset Password
  const [dataResetPassword, setDataResetPassword] = useState({
    newPassword: "",
  });

  const handleChangeResetPassword = (e) => {
    const { name, value } = e.target;
    setDataResetPassword((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();

    try {
      const postDataResetPass = {
        ...dataResetPassword,
      };
      const config = {
        method: "put",
        maxBodyLength: Infinity,
        url: "/api_w/users/resetpassword",
        headers: {
          Authorization: `${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
          db_name: process.env.REACT_APP_DB_NAME,
        },
        data: JSON.stringify(postDataResetPass),
      };
      const response = await axios.request(config);
      console.log(JSON.stringify(response.data));
      toast.success("Berhasil reset Password!");
      navigate("/admin/user");
    } catch (error) {
      console.log(error.response);
      toast.error(
        "Error Reset Password: " +
          (error.response?.data?.message || error.message)
      );
    }
  };

  const inputCls = "block w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm outline-none focus:border-brand-500 focus:ring-0 transition-colors";
  const labelCls = "mb-1.5 block text-sm font-semibold text-navy-700";

  const tabsData = [
    {
      label: "REGISTRASI",
      content: (
        <form onSubmit={handleRegister} className="space-y-5">
          {/* Avatar Preview */}
          {selectedFile && (
            <div className="flex items-center gap-4 p-4 rounded-2xl bg-gray-50 border border-gray-100">
              <img
                src={URL.createObjectURL(selectedFile)}
                alt="Preview"
                className="h-16 w-16 rounded-full object-cover ring-2 ring-brand-500/30"
              />
              <span className="text-sm text-gray-500">Preview foto profil</span>
            </div>
          )}
          <div>
            <label className={labelCls}>Foto Profil</label>
            <input
              type="file"
              name="profil_pict"
              onChange={handleFileChange}
              accept=".png,.jpg,.jpeg,.svg,.webp"
              className="block w-full text-sm text-gray-500 file:mr-4 file:rounded-lg file:border-0 file:bg-brand-50 file:px-4 file:py-2 file:text-sm file:font-semibold file:text-brand-500 hover:file:bg-brand-100 cursor-pointer"
            />
            <span className="mt-1 block text-xs text-gray-400">
              *Max size: 5MB, Format: .png, .jpg, .jpeg, .svg, .webp
            </span>
          </div>
          <div>
            <label className={labelCls}>Nama Lengkap</label>
            <input type="text" name="name" value={dataRegister.name} onChange={handleChange} className={inputCls} required />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <div>
              <label className={labelCls}>Username</label>
              <input type="text" name="username" value={dataRegister.username} onChange={handleChange} className={inputCls} required />
            </div>
            <div>
              <label className={labelCls}>Email</label>
              <input type="email" name="email" value={dataRegister.email} onChange={handleChange} className={inputCls} required />
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <div>
              <label className={labelCls}>Password</label>
              <input type="password" name="password" value={dataRegister.password} onChange={handleChange} className={inputCls} required />
            </div>
            <div>
              <label className={labelCls}>Nomor HP</label>
              <input type="text" name="phone" value={dataRegister.phone} onChange={handleChange} className={inputCls} />
            </div>
          </div>
          <div>
            <label className={labelCls}>Role</label>
            <select name="role" value={dataRegister.role} onChange={handleChange} className={inputCls} required>
              <option value="" disabled>Pilih Role</option>
              <option value="superadmin">Superadmin</option>
              <option value="admin">Admin</option>
              <option value="user">User</option>
            </select>
          </div>
          <div className="flex justify-end gap-3 pt-2">
            <button type="button" onClick={handleCancel} className="rounded-xl border border-gray-200 px-5 py-3 text-sm font-semibold text-gray-600 hover:bg-gray-50 transition-colors">
              Batal
            </button>
            <button type="submit" className="rounded-xl px-5 py-3 text-sm font-bold text-white transition-all hover:opacity-90" style={{ background: "linear-gradient(to right, #16a34a, #15803d)" }}>
              Tambah User
            </button>
          </div>
        </form>
      ),
    },
    {
      label: "UBAH PASSWORD",
      content: (
        <form onSubmit={handleChangePassword} className="space-y-5">
          <div>
            <label className={labelCls}>Password Lama</label>
            <input type="password" name="oldPassword" value={dataChangePassword.oldPassword} onChange={handleChangeUbahPassword} className={inputCls} />
          </div>
          <div>
            <label className={labelCls}>Password Baru</label>
            <input type="password" name="newPassword" value={dataChangePassword.newPassword} onChange={handleChangeUbahPassword} className={inputCls} />
          </div>
          <div>
            <label className={labelCls}>Konfirmasi Password Baru</label>
            <input type="password" name="newPasswordValidate" value={dataChangePassword.newPasswordValidate} onChange={handleChangeUbahPassword} className={inputCls} />
          </div>
          <div className="flex justify-end gap-3 pt-2">
            <button type="button" onClick={handleCancel} className="rounded-xl border border-gray-200 px-5 py-2.5 text-sm font-semibold text-gray-600 hover:bg-gray-50 transition-colors">
              Batal
            </button>
            <button type="submit" className="rounded-xl px-5 py-2.5 text-sm font-bold text-white transition-all hover:opacity-90" style={{ background: "linear-gradient(to right, #16a34a, #15803d)" }}>
              Ubah Password
            </button>
          </div>
        </form>
      ),
    },
    {
      label: "PASSWORD RESET",
      content: (
        <form onSubmit={handleResetPassword} className="space-y-5">
          <div>
            <label className={labelCls}>Password Baru</label>
            <input type="password" name="newPassword" value={dataResetPassword.newPassword} onChange={handleChangeResetPassword} className={inputCls} />
          </div>
          <div className="flex justify-end gap-3 pt-2">
            <button type="button" onClick={handleCancel} className="rounded-xl border border-gray-200 px-5 py-2.5 text-sm font-semibold text-gray-600 hover:bg-gray-50 transition-colors">
              Batal
            </button>
            <button type="submit" className="rounded-xl px-5 py-2.5 text-sm font-bold text-white transition-all hover:opacity-90" style={{ background: "linear-gradient(to right, #16a34a, #15803d)" }}>
              Reset Password
            </button>
          </div>
        </form>
      ),
    },
  ];

  return (
    <div className="mt-5 px-2">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-navy-700">Manajemen Akun</h2>
        <p className="text-sm text-gray-500 mt-1">Tambah akun, ubah password, atau reset password pengguna</p>
      </div>
      <div className="rounded-2xl bg-white shadow-sm p-6">
        <Tabs tabs={tabsData} />
      </div>
    </div>
  );
}

export default AddUser;
